import {
  createContext,
  type ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

declare global {
  interface Window {
    [index: string]: any;
    VWO?: {
      flags?: string[];
      event?: (name: string) => void;
    };
  }
}

// Add more A/B test flags
const FLAGS_EVENT_NAME = "flags-update";
const availableFlags = [
  "_flags_static_map",
  "_flags_static_map_scaled",
  "_flags_static_map_modal",
] as const;

const parseFlags = () => availableFlags.filter((flag) => window[flag] === true);

const Context = createContext<{ flags: string[] }>({ flags: [] });

export const VWOProvider = ({ children }: { children: ReactNode }) => {
  const [flags, setFlags] = useState<string[]>(parseFlags());
  useEffect(() => {
    const handler = () => {
      setFlags(parseFlags());
    };

    window.addEventListener(FLAGS_EVENT_NAME, handler);

    return () => window.removeEventListener(FLAGS_EVENT_NAME, handler);
  }, []);

  return <Context.Provider value={{ flags }}>{children}</Context.Provider>;
};

export const useVWO = () => {
  const context = useContext(Context);
  const flags = context.flags;

  return {
    hasFlag(id: (typeof availableFlags)[number]) {
      if (import.meta.env.DOQ_ENVIRONMENT === "development") return true;

      return flags.includes(id);
    },
    sendEvent(name: string) {
      window.VWO?.event?.(name);
    },
  };
};
